import { z } from 'zod';

export const DeliverServiceOrderBodySchema = z.object({
  creditOverrideReason: z.string().min(1).max(500).optional(),
});

export type DeliverServiceOrderBody = z.infer<typeof DeliverServiceOrderBodySchema>;
